(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();




//   $('.related-collection').slick({
//   dots: true,
//   infinite: true,
//   adaptiveHeight: true,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   speed:200
// });
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-section"] && !Shopify.designMode) return;
  try {
    
if (typeof Masonry === 'undefined') {
  const script = document.createElement('script');
  script.src = 'https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js';
  script.onload = initMasonry;
  document.head.appendChild(script);
} else {
  initMasonry();
}

function initMasonry() {
  const grids = document.querySelectorAll('.ugc-grid');

  grids.forEach(grid => {
    const msnry = new Masonry(grid, {
      itemSelector: '.ugc-item',
      percentPosition: true
    });

    // Ensure layout after all images load
    imagesLoaded(grid, () => msnry.layout());
  });
}

if (typeof imagesLoaded === 'undefined') {
  const imgScript = document.createElement('script');
  imgScript.src = 'https://unpkg.com/imagesloaded@5/imagesloaded.pkgd.min.js';
  document.head.appendChild(imgScript);
}



document.addEventListener('click', async function(e) {
  const tile = e.target.closest('.ugc-item');
  const tile_overlay = tile?.querySelector('.overlay-on-image');
  const add_all_to_cart_btn = document.querySelector('#add-all-to-cart');
  const popup = document.querySelector('.popup-product-main');
  const mainImage = popup.querySelector('.popup-main-image');
  const productWrap = popup.querySelector('.main-grid-wrap');

  // 🔹 Open popup
  if (tile) {
  if(!tile_overlay){
      add_all_to_cart_btn.style.display = 'none';
    }else{
      add_all_to_cart_btn.style.display = 'block';
    }
    const image = tile.dataset.image;
    const products = tile.querySelectorAll('.ugc-product-item');
    mainImage.src = image;
    productWrap.innerHTML = '';

    // Build product cards
    products.forEach(product => {
      const variants = product.querySelectorAll('.ugc-variant-item');
      const firstVariant = variants[0];
      const title = product.dataset.title || '';
      const link = product.dataset.link || '';
      const image = product.dataset.image || '';
      let priceText = '';
      let variantOptions = '';

      if (variants.length > 1) {
        variantOptions = `<select class="variant-select">`;
        variants.forEach(v => {

          let WPD_handels='';
       //for(var i=0;i<products.length;i++) {
         WPD_handels+=product.dataset.handle +',';
       //}
              
         var wcpcartdata = [];
          var xhttp = new XMLHttpRequest();
          xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
              wcpcartdata=JSON.parse(this.responseText);
            }
          };          
          xhttp.open("GET", '/search/?view=wcp_discount_api&handle='+WPD_handels, false);
          xhttp.send();
         
      	//for(var i=0;i<products.length;i++) { 
          for(var j=0;j<wcpcartdata.products.length;j++){
            if(product.dataset.productId == wcpcartdata.products[j].id){
              for(var y=0; y<wcpcartdata.products[j].variants.length; y++){
                if(v.dataset.variantId == wcpcartdata.products[j].variants[y].id){
                  v.dataset.price='$'+wcpcartdata.products[j].variants[y].wpd_price;       
                } 
              }
                
            }
          }       
       //}

          variantOptions += `<option value="${v.dataset.variantId}">
            ${v.dataset.variantTitle} - ${v.dataset.price}
          </option>`;
        });
        variantOptions += `</select>`;
        priceText = firstVariant.dataset.price || '';
      } else if (variants.length === 1) {
        variantOptions = `<input type="hidden" class="variant-select" value="${firstVariant.dataset.variantId}">`;
        priceText = firstVariant.dataset.price || '';
      }

        let WPD_handels='';
       //for(var i=0;i<products.length;i++) {
         WPD_handels+=product.dataset.handle +',';
       //}
              
         var wcpcartdata = [];
          var xhttp = new XMLHttpRequest();
          xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
              wcpcartdata=JSON.parse(this.responseText);
            }
          };          
          xhttp.open("GET", '/search/?view=wcp_discount_api&handle='+WPD_handels, false);
          xhttp.send();
         
      	//for(var i=0;i<products.length;i++) { 
          for(var j=0;j<wcpcartdata.products.length;j++){
            if(product.dataset.productId == wcpcartdata.products[j].id){
               priceText='$'+wcpcartdata.products[j].variants[0].wpd_price;          
            }
          }       
       //}

      const html = `
        <div class="product-card">
          <img src="${image}" alt="${title}">
          <a href="${link}">${title}</a>
          <p class="price">${priceText}</p>
          ${variantOptions}
          <button class="btn add-to-cart">Add to Cart</button>
        </div>
      `;
      productWrap.insertAdjacentHTML('beforeend', html);
    });

    popup.style.display = 'block';
    document.body.classList.add('ugc-popup-open');
  }

  // 🔹 Close popup
  if (e.target.closest('.close-popup-product')) {
    popup.style.display = 'none';
    document.body.classList.remove('ugc-popup-open');
  }

  // 🔹 Single product Add to Cart
  if (e.target.classList.contains('add-to-cart')) {
    const card = e.target.closest('.product-card');
    const variantId = card.querySelector('.variant-select')?.value;

    if (!variantId) {
      alert('Please select a variant');
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        e.target.textContent = 'Added!';
        e.target.disabled = true;
        setTimeout(() => {
          e.target.textContent = 'Add to Cart';
          e.target.disabled = false;
        }, 2000);
      } else {
        const data = await res.json();
        alert(data.description || 'Error adding product.');
      }
    } catch (err) {
      console.error(err);
    }
  }

 // 🔹 Add All to Cart with animation
if (e.target.id === 'add-all-to-cart') {
  const btn = e.target;
  const variantSelects = popup.querySelectorAll('.variant-select');
  const variantIds = [...variantSelects].map(v => v.value).filter(Boolean);

  if (!variantIds.length) {
    alert('No products found for this UGC post.');
    return;
  }

  // Show loading state
  btn.disabled = true;
  btn.innerHTML = `<span class="spinner"></span> Adding...`;

  for (const id of variantIds) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });
  }

  // Show success message
  btn.innerHTML = `✅ Added! Redirecting...`;

  // Wait briefly before redirect
  setTimeout(() => {
    window.location.href = '/cart';
  }, 1000);
}

});

  } catch(e) { console.error(e); }
})();
})();
